var __WEBPACK_NAMESPACE_OBJECT__ = require("blueimp-load-image/js/load-image-exif");